var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTm = function SvgIconTm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0c-.896 0-1.77.098-2.61.285l-.52 11.714.52 11.715c.84.186 1.714.285 2.61.285 6.627 0 12-5.372 12-12 0-6.627-5.373-12-12-12M3.13 3.917A11.96 11.96 0 0 0 0 12c0 3.113 1.186 5.95 3.13 8.082L3.652 12z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.551 9.052a3.65 3.65 0 0 0-1.496-4.327q.385.048.765.184a3.652 3.652 0 1 1-3.174 6.531 3.65 3.65 0 0 0 3.905-2.388M14.277 4.274l-.513.663-.79-.283.473.693-.513.663.804-.235.472.692.025-.837.805-.235-.789-.283z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.662 6.435-.513.663-.789-.283.472.693-.513.663.805-.235.472.693.025-.838.805-.235-.789-.283zM11.833 5.06l-.513.663-.789-.283.472.693-.513.663.805-.235.472.693.025-.838.805-.235-.79-.283zM11.778 7.534l-.513.663-.79-.283.473.693-.513.663.804-.235.472.693.025-.838.805-.235-.789-.283zM14.132 8.38l-.513.663-.789-.283.472.692-.513.663.805-.235.472.693.025-.838.805-.234-.79-.283z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M3.13 3.918v16.165a12 12 0 0 0 6.26 3.632V.285a12 12 0 0 0-6.26 3.633"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m5.52 6.317-1.048-.78V4.432l1.048-.78h1.482l1.048.78v1.105l-1.048.78z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.261 3.652H5.52l-1.048.78v.54h1.79zM6.26 6.317h.742l1.048-.781v-.564H6.26z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m5.52 20.349-1.048-.781v-1.105l1.048-.78h1.482l1.048.78v1.105l-1.048.78z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FF9811"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.261 17.683H5.52l-1.048.78v.54h1.79zM6.26 20.35h.742l1.048-.782v-.563H6.26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#496E2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.52 13.332-1.048-.78v-1.105l1.048-.78h1.482l1.048.78v1.105l-1.048.78zM8.087 15.051H7.63v-.456h-.802l-.567-.567-.568.567h-.802v.456h-.456v.913h.456v.457h.802l.568.567.567-.567h.802v-.457h.457zM8.087 8.036H7.63v-.457h-.802l-.567-.567-.568.567h-.802v.457h-.456v.913h.456v.457h.802l.568.567.567-.567h.802v-.457h.457z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.783 11.48H5.739v1.043h1.044zM6.261 9.015a.522.522 0 1 0 0-1.044.522.522 0 0 0 0 1.044M6.261 16.03a.522.522 0 1 0 0-1.043.522.522 0 0 0 0 1.044"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTm;